import React from 'react'
import { StyleProp, TextStyle, ViewStyle } from 'react-native'

import { Icon, Pressable, Stack, XStack } from '@zet/design-system'

import { B26, M14 } from '../typography'

interface IProps {
  title: string
  subTitle?: string
  onCrossPress?: () => void
  progressBar?: number
  totalSteps?: number
  className?: string
  textStyle?: string
  innerContainerClassName?: string
  textStyleOverride?: StyleProp<TextStyle>
  containerStyle?: StyleProp<ViewStyle>
}

export const ScreenTitle: React.FC<IProps> = ({
  title,
  subTitle,
  onCrossPress,
  className,
  textStyle,
  innerContainerClassName,
  containerStyle,
  textStyleOverride,
}) => {
  return (
    <XStack
      style={containerStyle}
      className={`${subTitle ? 'mb-4' : 'mb-3'} items-center justify-center ${className}`}
    >
      <Stack
        className={`flex-1 justify-center px-2 ${innerContainerClassName}`}
      >
        <B26
          style={textStyleOverride}
          className={`text-center py-2 leading-tight ${textStyle}`}
        >
          {title}
        </B26>
        {subTitle ? (
          <M14 className="text-center leading-tight text-[#24262BA6]">
            {subTitle}
          </M14>
        ) : null}
      </Stack>

      {onCrossPress && (
        <Pressable onPress={onCrossPress}>
          <Icon type="Close" />
        </Pressable>
      )}
    </XStack>
  )
}
